var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconElectricityActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Elekter - Men\xFC\xFC_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elekter---Era---Leping",
    transform: "translate(-934.000000, -31.000000)",
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(427.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(508.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flash-1",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.848,7.53733333 C12.0421347,7.32693877 12.0504476,7.06300763 11.8697317,6.84736571 C11.6890157,6.6317238 11.3475219,6.49808203 10.977,6.498 L7.5,6.498 L7.5,0.498 L0.152,8.45933333 C-0.0423027635,8.66962614 -0.0506807724,8.93355388 0.130103121,9.1491385 C0.310887015,9.36472312 0.65252009,9.49820172 1.023,9.498 L4.5,9.498 L4.5,15.498 L11.848,7.53733333 Z",
    id: "Elekter---Men\\xFC\\xFC"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElectricityActive);
export default __webpack_public_path__ + "static/media/Icon-Electricity_Active.d0ea13234a756747c6be0138e965c24f.svg";
export { ForwardRef as ReactComponent };